// extracted by mini-css-extract-plugin
module.exports = {"Container":"style_Container__akcGf","Cols_3":"style_Cols_3__jDcpu","Cols_2":"style_Cols_2__1F1Jm","FullScreen":"style_FullScreen__1dZxT"};